import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ApiProvider } from "../ApiProvider";
import { getInitialState } from "../helpers";

export interface IEventSummaryPayload {
	EventId: number | undefined;
	CompanyName: string;
}

export interface ISoldData {
	SoldTickets: number | null;
	SoldCost: number | null;
	SoldPrice: number | null;
	SoldCommission: number | null;
	SoldPayment: number | null;
	SoldProfit: number | null;
	SoldProfitMargin: number | null;
}

export interface IOpenData {
	OpenTickets: number | null;
	OpenCost: number | null;
	OpenPrice: number | null;
	OpenPosition: number | null;
	OpenMargin: number | null;
}

export interface ITotalData {
	TotalTickets: number | null;
	TotalCost: number | null;
	TotalExpectedRevenue: number | null;
	TotalExpectedNet: number | null;
	TotalExpectedMargin: number | null;
}

export interface IEventSummaryData {
	Sold: ISoldData;
	Open: IOpenData;
	Total: ITotalData;
}

const initialState = getInitialState<IEventSummaryData | null>(null);

export const fetchEventSummary = createAsyncThunk<IEventSummaryData, IEventSummaryPayload>(
	"eventSummary/fetchEventSummary",
	async ({ EventId, CompanyName }, { rejectWithValue }) => {
		try {
			return await ApiProvider.default.get<IEventSummaryData>(
				`/api/Pricing/GetEventSummary?EventId=${EventId}&CompanyName=${encodeURIComponent(CompanyName)}`,
			);
		} catch (error) {
			if (error instanceof AxiosError) {
				return rejectWithValue(error.message);
			}
			return rejectWithValue("Unknown error");
		}
	},
);

export const eventSummarySlice = createSlice({
	name: "eventSummary",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchEventSummary.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchEventSummary.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(fetchEventSummary.rejected, (state, action) => {
				state.data = null;
				state.loading = false;
				state.error = action.payload as string;
			});
	},
});
